export * from '@taqueria/protocol/out/types/ConfigContractsDir';
